import { render } from "./SelectCompletedTraineesModal.vue?vue&type=template&id=cf87ac58&scoped=true"
import script from "./SelectCompletedTraineesModal.vue?vue&type=script&lang=js"
export * from "./SelectCompletedTraineesModal.vue?vue&type=script&lang=js"

import "./SelectCompletedTraineesModal.vue?vue&type=style&index=0&id=cf87ac58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf87ac58"]])

export default __exports__